import React, {useEffect, useRef, useState} from 'react';

const AccRadio = ({
                    propName,
                    propAccCode,
                    propUser
                  }) => {

  // console.log(props);

  // const [stVal, setVal] = useState(0);
  const refRadio1 = useRef(null);
  const refRadio2 = useRef(null);
  const refRadio3 = useRef(null);

  // const [adminAccCode, setAdminAccCode] = useState([]);
  // const [userAccCode, setUserAccCode] = useState([]);
  // const [accCode, setAccCode] = useState([]);

  useEffect(() => {
    //console.log(propAccCode);
    if (propAccCode === '0') {
      refRadio1.current.checked = true;
      refRadio2.current.checked = false;
      refRadio3.current.checked = false;
    } else if (propAccCode === '1') {
      // console.log("1!!!!!");
      refRadio1.current.checked = false;
      refRadio2.current.checked = true;
      refRadio3.current.checked = false;
    } else if (propAccCode === '2') {
      // console.log("2!!!!!");
      refRadio1.current.checked = false;
      refRadio2.current.checked = false;
      refRadio3.current.checked = true;
    }
  }, [propAccCode]);

  /*useEffect(() => {
    let code = propAccCode;
    if (propUser == 'admin') {
      // code = code / 10;
      code = code.substr(0, 1);
      console.log(code);

    } else if (propUser == 'user') {
      // code = code % 10;
      code = code.substr(1, 2);
      console.log(code);

    }
    console.log(propAccCode);
    setVal(code);
  }, [])*/

  /*useEffect(() => {
    if (stVal == 0) {
      refRadio1.current.checked = true
      refRadio2.current.checked = false
      refRadio3.current.checked = false
    } else if (stVal == 1) {
      refRadio1.current.checked = false
      refRadio2.current.checked = true
      refRadio3.current.checked = false
    } else if (stVal == 2) {
      refRadio1.current.checked = false
      refRadio2.current.checked = false
      refRadio3.current.checked = true
    }

  }, [stVal])*/

  return (
      <>
        <div className="form-check form-check-inline me-4">
          <input
              className="form-check-input" type="radio" value="0"
              id={`rb_${propUser}_${propName}_none`}
              name={`rb_${propUser}_${propName}`}
              ref={refRadio1}/>
          <label className="form-check-label" htmlFor={`rb_${propUser}_${propName}_none`}>권한 없음</label>
        </div>
        <div className="form-check form-check-inline me-4">
          <input
              className="form-check-input" type="radio" value="1"
              id={`rb_${propUser}_${propName}_read`}
              name={`rb_${propUser}_${propName}`}
              ref={refRadio2}/>
          <label className="form-check-label" htmlFor={`rb_${propUser}_${propName}_read`}>읽기</label>
        </div>
        <div className="form-check form-check-inline">
          <input
              className="form-check-input" type="radio" value="2"
              id={`rb_${propUser}_${propName}_write`}
              name={`rb_${propUser}_${propName}`}
              ref={refRadio3}/>
          <label className="form-check-label" htmlFor={`rb_${propUser}_${propName}_write`}>쓰기</label>
        </div>
      </>
  );
};

export default AccRadio;


